import { useContext, useState } from "react";

import Axios from "axios";
import { Button, Card, Col, Container, Form, Image, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import InputNumber from "../../components/inputs/InputNumber";
import Mobile from "../../components/inputs/Mobile";
import DashboardContext from "../../Context";

import { userbrowser } from './userbrowser'
import { useCookies } from "react-cookie";

import logo from './../../assets/images/logo.png'
import { Helmet } from "react-helmet";


export default function LoginPage() {

    const [, setCookie] = useCookies(['Authentication']);

    const { urldashboard, handelusername, handelUserCellPhone, handelsidebar, authentication, handelLogin, handelAuthentication } = useContext(DashboardContext);

    const [LodingForm, setLodingForm] = useState(false)

    const [isvrefiyCode, setIsvrefiyCode] = useState(false)

    const [cellPhone, setCellPhone] = useState('')

    const [otpCode, setOtpCode] = useState('')

    const history = useHistory();

    const handelValue = (name, value) => {
        switch (name) {
            case 'cellPhone':
                setCellPhone(value)
                break;
            case 'otp':
                setOtpCode(value)
                break;

            default:
                break;
        }
    }

    const [timer, setTimer] = useState('')

    const timerfuc = (entertime) => {

        const timer = setInterval(() => {

            entertime--

            let Minutes = parseInt(entertime / 60)

            Minutes = Minutes < 10 ? `0${Minutes}` : Minutes

            let Second = entertime % 60

            Second = Second < 10 ? `0${Second}` : Second


            setTimer(` ${Second} : ${Minutes}`)

            if (entertime < 1) {
                clearInterval(timer);
                setTimer('')
            }

        }, 1000)



    }


    const handelSendMobile = async () => {
        try {
            const res = await Axios.post(`${urldashboard}/user/sendcode`, JSON.stringify({ cellPhone }),
                {
                    headers: {
                        "Content-Type": "application/json; charset=utf-8 "
                    }
                })

            const data = await res.data
            setLodingForm(false)
            setIsvrefiyCode(true)
            timerfuc(120)
            toast.success(data.message, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } catch (error) {
            if (error.message === 'Network Error') {
                toast.error('اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید:(', {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setLodingForm(false)
            }
            else {
                setLodingForm(false)
                toast.error(error.response.data.message, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    const handelsildbar = async (dataresive) => {
        try {
            const res = await Axios.get(`${urldashboard}/accesses/get`, {
                headers: {
                    "Authorization": `Bearer ${dataresive.accessToken}`
                }
            })
            const data = await res.data
            handelsidebar(data.data)
            setLodingForm(false)
            handelLogin(true)
            history.push('/')
            handelUserCellPhone(dataresive.introducerCellPhone);
            handelusername(dataresive.fullName);
            handelAuthentication(`Bearer ${dataresive.accessToken}`)
            setCookie('Authentication', `Bearer ${dataresive.accessToken}`, { path: '/', expires: new Date(dataresive.expiresIn), httpOnly: false, sameSite: 'strict' })

            toast.success('خوش آمدید', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } catch (error) {
            if (error.message === 'Network Error') {
                toast.error('اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید:(', {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setLodingForm(false)
            }
            else {
                setLodingForm(false)
                toast.error(error.response.data.message, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    const handelsendLogin = async () => {

        const dataFrom = {
            mobile: cellPhone,
            otp: otpCode,
            operatingSystem: userbrowser.os,
            operatingSystemVersion: userbrowser.osVersion,
            deviceModel: userbrowser.browserVersion,
            deviceId: `${userbrowser.os}${userbrowser.osVersion}${userbrowser.browserVersion}`,
            applicationVersion: "1.0.0",
            applicationType: 3,
            googleNotificationToken: ""
        }



        try {
            const res = await Axios.post(`${urldashboard}/user/login`, JSON.stringify(dataFrom), {
                headers: {
                    "Content-Type": "application/json; charset=utf-8 "
                }
            })
            const dataresive = await res.data.data;
            handelsildbar(dataresive);
        } catch (error) {
            if (error.message === 'Network Error') {
                toast.error('اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید:(', {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setLodingForm(false)
            }
            else {
                toast.error(error.response.data.message, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setLodingForm(false)
            }


        }
    }

    const handelSubmit = event => {
        event.preventDefault()

        setLodingForm(true)

        if (isvrefiyCode) {
            if (!otpCode) {
                setLodingForm(false)

                toast.error("لطفا  کد ارسال شده  را وارد کنید", {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
            else {
                handelsendLogin()
            }
        }
        else {

            if (!cellPhone) {

                setLodingForm(false)

                toast.error("لطفا شماره موبایل را وارد کنید", {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
            else {
                handelSendMobile()
            }
        }

    }

    const titlePage = 'ورود '
    const urlpage = '/login'
    return (
        <Container fluid>
            <Helmet>
                <title>{`${titlePage} | داشبورد سرویک`}</title>
                <meta name='description' content={`${titlePage} | داشبورد سرویک`} />
                <link rel='canonical' href={`${urlpage}`} />
                <meta property="twitter:title" content={titlePage} />
                <meta property="twitter:description" content={`${titlePage} | داشبورد سرویک`} />
                <meta property="og:title" content={titlePage} />
                <meta property="og:description" content={`${titlePage} | داشبورد سرویک`} />
                <meta property="og:url" content={`${urlpage}`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="fa-IR" />
            </Helmet>
            <Row>
                <Col lg='4' md='4' sm='6' xs='12' className='mx-auto mt-5 ' >
                    <Card className=' d-flex justify-content-center align-content-center'>
                        <Card.Header className='d-flex justify-content-center align-content-center'>
                            <Image src={logo} rounded width='95' height='25' />
                        </Card.Header>
                        <Card.Body>
                            <Form method='post' >
                                <Form.Row>
                                    <Col>

                                        {
                                            isvrefiyCode ?
                                                <InputNumber name='otp' label='کد تایید'
                                                    Placeholder='کد پیامک شده را وارد کنید'
                                                    autoComplete
                                                    maxLength='6' handelValue={handelValue} />

                                                : <Mobile label="شماره همراه" handelValue={handelValue} autoComplete
                                                    name='cellPhone' Placeholder='شماره موبایل' />
                                        }
                                    </Col>
                                </Form.Row>
                                <Form.Row>
                                    <Col lg='12' md='12' sm='12' xs='12' >
                                        <Button type='submit' className='btn-block' disabled={LodingForm} onClick={handelSubmit}  >
                                            {
                                                LodingForm ?
                                                    <i className="fa fa-spinner fa-pulse fa-fw"></i>
                                                    : isvrefiyCode ? "تایید" : 'ارسال کد'
                                            }
                                        </Button>
                                    </Col>
                                </Form.Row>
                            </Form>
                        </Card.Body>
                        <Card.Footer className=' align-content-center justify-content-center text-center' >
                            {
                                isvrefiyCode ?
                                    <div>
                                        {
                                            timer ? <span >{timer}</span>
                                                : <span onClick={handelSendMobile} >ارسال مجدد کد</span>
                                        }
                                        <br />
                                        <span onClick={() => { setIsvrefiyCode(false); setLodingForm(false) }}
                                            className=' d-flex   mt-3 align-content-center justify-content-center text-center'
                                        > تغییر شماره موبایل </span>
                                    </div>
                                    : null
                            }
                        </Card.Footer>
                    </Card>
                </Col>
            </Row>
        </Container >
    )
}
